import { useEffect, useState } from "react";
import { getDatabase, ref, get } from "firebase/database";
import { Link } from "react-router-dom";
import { getAuth } from "firebase/auth";
import "./homeMusic.css";

function HomeMusic() {
  const [musicEvents, setMusicEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [eventReactions, setEventReactions] = useState({});
  const [currentUserId, setCurrentUserId] = useState(null);

  // IMAGE HELPER
  const getEventBackgroundImage = (event) => {
    const type = (event.EVENT_TYPE || "other").toLowerCase();
    const imgNUM = event.EVENT_IMAGENUM || "";
    const customImage = event.EVENT_IMAGE || null;

    const imageMap = {
      other: `other${imgNUM}`,
    };

    const presetImg = imgNUM ? imageMap[type] || imageMap.other : null;

    // Custom image
    if (customImage) {
      return `../assets/img/uploads/events/${event.EVENT_IMAGE}.png`
    }

    // Preset image
    if (presetImg) {
      return `/assets/img/${type}/${presetImg}-640.png`;
    }

    // No image
    return null;
  };

  // Format event date and time
  const formatEventDateTime = (dateStr, startTime, endTime) => {
    if (!dateStr) return "";

    const [day, month, year] = dateStr.split("/");
    const date = new Date(year, month - 1, day);

    const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
    const monthName = date.toLocaleDateString("en-US", { month: "long" });
    const dayNum = parseInt(day);

    let suffix = "th";
    if (dayNum % 10 === 1 && dayNum !== 11) suffix = "st";
    else if (dayNum % 10 === 2 && dayNum !== 12) suffix = "nd";
    else if (dayNum % 10 === 3 && dayNum !== 13) suffix = "rd";

    const formattedDate = `${dayName} ${dayNum}${suffix} ${monthName} ${year}`;

    if (startTime && endTime) {
      return `${formattedDate} - ${startTime} - ${endTime}`;
    }

    return formattedDate;
  };

  // Check if event date is today (considering EVENT_EXTRADAYS)
  const isToday = (dateStr, extraDays = 0) => {
    if (!dateStr) return false;

    const [day, month, year] = dateStr.split("/");
    const eventDate = new Date(year, month - 1, day);
    const today = new Date();

    // Calculate the end date (start date + extra days if they exist)
    let endDate = new Date(year, month - 1, day);
    if (extraDays && Number(extraDays) > 0) {
      endDate.setDate(endDate.getDate() + Number(extraDays));
    }

    // Check if today falls within the event period (inclusive)
    eventDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return today.getTime() >= eventDate.getTime() && today.getTime() <= endDate.getTime();
  };

  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      setCurrentUserId(user.uid);
    }
  }, []);

  useEffect(() => {
    const fetchMusicEvents = async () => {
      try {
        const db = getDatabase();
        const snapshot = await get(ref(db, "EVENTS/EVENT/MUSIC"));

        if (snapshot.exists()) {
          const eventsData = snapshot.val();
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const musicUpcoming = Object.entries(eventsData)
            .filter(([_, event]) => {
              if (!event.EVENT_DATE) return false;
              if (event.EVENT_PUBLIC !== "Y") return false;

              const [day, month, year] = event.EVENT_DATE.split("/");
              
              // Calculate the end date (start date + extra days if they exist)
              let endDate = new Date(year, month - 1, day);
              if (event.EVENT_EXTRADAYS && Number(event.EVENT_EXTRADAYS) > 0) {
                endDate.setDate(endDate.getDate() + Number(event.EVENT_EXTRADAYS));
              }

              return endDate >= today;
            })
            .map(([slug, event]) => ({ slug, ...event }))
            .sort((a, b) => {
              const [dayA, monthA, yearA] = a.EVENT_DATE.split("/");
              const [dayB, monthB, yearB] = b.EVENT_DATE.split("/");
              const dateA = new Date(yearA, monthA - 1, dayA);
              const dateB = new Date(yearB, monthB - 1, dayB);

              return dateA - dateB;
            })
            .slice(0, 4);

          setMusicEvents(musicUpcoming);
        }
      } catch (error) {
        // console.error("Error loading music events:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMusicEvents();
  }, []);

  useEffect(() => {
    const loadReactions = async () => {
      if (musicEvents.length === 0) return;

      try {
        const db = getDatabase();
        const reactionsData = {};

        for (const event of musicEvents) {
          try {
            const reactionsPath = `EVENTS/EVENT/MUSIC/${event.slug}/REACTIONS`;
            const reactionsRef = ref(db, reactionsPath);
            const reactionsSnap = await get(reactionsRef);

            let likes = 0;
            let dislikes = 0;
            let userReact = null;

            if (reactionsSnap.exists()) {
              const reactions = reactionsSnap.val();
              
              for (const userId in reactions) {
                const reaction = reactions[userId];
                
                if (reaction === 'LIKE') {
                  likes++;
                  if (currentUserId === userId) {
                    userReact = 'LIKE';
                  }
                } else if (reaction === 'DISLIKE') {
                  dislikes++;
                  if (currentUserId === userId) {
                    userReact = 'DISLIKE';
                  }
                }
              }
            }

            reactionsData[event.slug] = { likes, dislikes, userReact };
          } catch (err) {
            reactionsData[event.slug] = { likes: 0, dislikes: 0, userReact: null };
          }
        }

        setEventReactions(reactionsData);
      } catch (err) {
        // Error loading reactions
      }
    };

    loadReactions();
  }, [musicEvents, currentUserId]);

  if (loading) {
    return (
       <></>
    );
  }

  if (musicEvents.length === 0) {
    return (
       <></>
    );
  }

  return (
    <div className="container-md py-5">
      <div className="row justify-content-between align-items-center">
          <div className="col-8 text-start">
            <p className="event-sub-text mb-2 ">Upcoming</p>
            <h3 className="home-banner-title mb-3 fw-medium"> <Link className="primary-link" to="/Music" > Music  Events.</Link></h3>
          </div>

      </div>

    <div className="home-music-section">
      <div className="home-music-grid">
        {musicEvents.map((event) => {
          const bgImage = getEventBackgroundImage(event);

          return (
            <Link
              key={event.EVENT_SLUG}
              to={`/event/${event.EVENT_URLKEY}/${event.EVENT_SLUG}`}
              className={`home-music-card card-rotate event-image-fallback event-image-${event.EVENT_TYPE}`}
              style={{
                backgroundImage: bgImage ? `url(${bgImage})` : "",
              }}
            >
         
                <div className={`home-music-overlay ${
                isToday(event.EVENT_DATE, event.EVENT_EXTRADAYS) ? "today-border" : ""
              }`}></div>
         
              {isToday(event.EVENT_DATE, event.EVENT_EXTRADAYS) && (
                <div className="today-border-badge">Today</div>
              )}

              <div className="home-music-card-content">

                {event.EVENT_SHOWREACTIONS === "Y" && eventReactions[event.slug]?.likes > 0 && (
                  <button className="event-badges me-2"> 
                  <span><i className="bi bi-hand-thumbs-up me-1 recommend-badge2 mb-0"></i>  {eventReactions[event.slug].likes} </span> 
                  </button>
                )}
            
                {event.EVENT_WERECOMMEND === "Y" &&(
                    <button className="event-badges"> 
                    <span>  <i className="bi  bi-suit-heart we-recommend-badge2"></i>  </span> 
                    </button>
                  )}
                <h5 className="home-music-event-name">
                  {event.EVENT_NAME}
                </h5>

                <div className="home-music-info">
                  <span className="home-music-date">
                    {formatEventDateTime(
                      event.EVENT_DATE
                    )}
                  </span>

                  {event.EVENT_LOCATION && (
                    <span className="home-music-location">
                      <i className="bi bi-geo-alt"></i> {event.EVENT_LOCATION}
                    </span>
                  )}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>

    </div>
  );
}

export default HomeMusic;